<template>
    <el-card class="box-card">
        <div class="component-content">
            <section class="content">
                <el-card>
                    <el-form :inline="true" label-suffix=":">
                        <el-form-item label='道具编号'>
                            <el-input v-model="propForm.id" placeholder=''></el-input>
                        </el-form-item>
                        <el-form-item label='道具大类'>
                            <el-select v-model="propForm.type" clearable>
                                <el-option :key="index"
                                           v-for="(item,index) in options"
                                           :label="item.label"
                                           :value="item.value"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <el-button size="small" type="primary" @click="propQuery">查询</el-button>
                        </el-form-item>
                    </el-form>
                </el-card>

                <el-table :data="dataHandled" border style="margin-top:20px;width: 100%">
                    <el-table-column prop="id" label='编号' width="100">
                    </el-table-column>
                    <el-table-column label='图标' width="100">
                        <template slot-scope="scope">
                            <el-image class="prop-img" :src="'./static/item_icon/'+ scope.row.id +'.png'"
                                      fit="cover">
                                <div slot="error" class="image-slot">
                                    <span>无</span>
                                </div>
                            </el-image>
                        </template>
                    </el-table-column>
                    <el-table-column prop="big_type" label='大类' width="100">
                        <template slot-scope="scope">
                            <span v-for="item in options" v-if="item.value == scope.row.big_type">{{item.label}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label='名称' width="150">
                        <template slot-scope="scope">
                            <span>{{$t(scope.row.name)}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label='描述'>
                        <template slot-scope="scope">
                            <span>{{$t(scope.row.description)}}</span>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="pagination">
                    <el-pagination @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pageSize"
                                   layout="total, prev, pager, next, jumper" :total="totalRow">
                    </el-pagination>
                </div>
            </section>
        </div>
    </el-card>
</template>

<script>
    import paginationController from '../../mixins/pagination'
    import actionConfirm from '../../mixins/action_confirm'
    import {
        mapState
    } from 'vuex';
    import commonApi from '../../service/common_api'

    export default {
        name: "prop_view",
        data () {
            return {
                propForm: {
                    id: '',
                    type: ''
                },
                arrProp0: [],
                arrProp3: [],
                arrProp4: [],
                arrProp6: [],
                arrProp7: [],
                arrProp9: [],
                arrProp10: [],
                arrProp11: [],
                arrProp12: [],
                arrProp13: [],
                arrProp14: [],
                arrProp15: [],
                arrProp16: [],
                arrProp17: [],
                arrProp18: [],
                arrProp19: [],
                arrProp20: [],
                arrProp21: [],
                arrProp22: [],
                arrConditionProp:[],
                monsterConfigs: [],
                propConfig: [],
                emblemEffectConfig: [],
                godConfigs: [],
                wallGainType: [],
                skinGainType: [],
                emblemEntryConfigs: [],
                emblemMainConfigs: [],
                emblemFateConfigs: [],

                options: [
                    {
                        value: '0',
                        label: this.$t("reward_editor.39")
                    },
                    {
                        value: '3',
                        label: this.$t("reward_editor.42")
                    },
                    {
                        value: '4',
                        label: this.$t("reward_editor.43")
                    },
                    {
                        value: '5',
                        label: '约束性道具'
                    },
                    {
                        value: '9',
                        label: this.$t("reward_editor.47")
                    },
                    {
                        value: '10',
                        label: '回复类道具'
                    },
                    {
                        value: '11',
                        label: '头像'
                    },
                    {
                        value: '12',
                        label: '头像框'
                    },
                    {
                        value: '13',
                        label: '宝箱'
                    },
                    {
                        value: '14',
                        label: '皮肤'
                    },
                    {
                        value: '15',
                        label: '时效类道具'
                    },
                    {
                        value: '17',
                        label: '起源盘'
                    },
                    {
                        value: '20',
                        label: '聊天框'
                    } ,
                    {
                        value: '21',
                        label: '战斗框'
                    } ,
                    {
                        value: '22',
                        label: '元核碎片'
                    }
                ],

                monsterRaceOptions: []
            }
        },
        mixins: [paginationController, actionConfirm],
        computed: {
            ...mapState({
                token: state => state.user.userInfo.loginToken,
            }),
        },
        mounted() {
            this.initData();
        },
        methods: {
            initData: function() {
                let self = this;
                let tables = 'monster_config,war_groove_config,skin_config,god_config,emblem_effect_config,prop_config';
                commonApi.getConfs({
                    tables: tables
                }).then(res => {
                    self.monsterConfigs = [];
                    self.propConfig = res.prop_config;
                    self.emblemEffectConfig = res.emblem_effect_config;
                    self.godConfigs = res.god_config;
                    self.wallGainType = res.war_groove_config;
                    self.skinGainType = res.skin_config;

                    res.monster_config.forEach(configItem=>{
                        if (configItem.special === 0){
                            self.monsterConfigs.push(configItem);
                        }
                    })

                    self.totalRow = self.propConfig.length;
                    self.rawData = self.propConfig;
                    self.dataHandled = self.propConfig;


                    let arrProp0 = [];
                    let arrProp3 = [];
                    let arrProp4 = [];
                    let arrConditionProp = [];
                    let arrProp9 = [];
                    let arrProp10 = [];
                    let arrProp11 = [];
                    let arrProp12 = [];
                    let arrProp13 = [];
                    let arrProp14 = [];
                    let arrProp15 = [];
                    let arrProp16 = [];
                    let arrProp18 = [];
                    let arrProp20 = [];
                    let arrProp21 = [];
                    let arrProp22 = [];
                    res.prop_config.forEach(function(item) {
                        let type = item.big_type;
                        if (type == 0) {
                            arrProp0.push(item);
                        } else if (type == 3) {
                            arrProp3.push(item);
                        }  else if (type == 5) {
                            arrConditionProp.push(item);
                        }else if (type == 9) {
                            arrProp9.push(item);
                        }else if(type == 4){
                            arrProp4.push(item);
                        } else if (type == 10) {
                            arrProp10.push(item)
                        } else if (type == 11) {
                            arrProp11.push(item)
                        } else if (type == 12) {
                            arrProp12.push(item)
                        } else if (type == 13) {
                            arrProp13.push(item)
                        } else if (type == 14) {
                            arrProp14.push(item)
                        } else if (type == 15) {
                            arrProp15.push(item)
                        } else if (type == 16) {
                            arrProp16.push(item)
                        } else if (type == 20) {
                            arrProp20.push(item)
                        } else if (type == 21) {
                            arrProp21.push(item)
                        } else if (type == 22) {
                            arrProp22.push(item)
                        }
                    });
                    self.arrProp0 = arrProp0;
                    self.arrProp3 = arrProp3;
                    self.arrProp4 = arrProp4;
                    self.arrProp16 = arrProp16;
                    self.arrProp20 = arrProp20;
                    self.arrProp21 = arrProp21;
                    self.arrProp22 = arrProp22;
                    self.arrConditionProp = arrConditionProp;
                    //元核属性类型: 0-主属性;1-二字词条;2-四字词条;3-宿命
                    let tw = {
                        value: 1,
                        label: this.$t("reward_editor.37"),
                        children: []
                    };
                    let fw = {
                        value: 2,
                        label: this.$t("reward_editor.38"),
                        children: []
                    };
                    let special = {
                        value: 3,
                        label: this.$t("reward_editor.52"),
                        children: [{
                            value: 0,
                            label: this.$t("reward_editor.48"),
                        }]
                    }

                    let twConfigs = [];
                    let fwConfigs = [];
                    res.emblem_effect_config.forEach(function(item) {
                        if (item.type == 0) {
                            self.emblemMainConfigs.push(item);
                        } else if (item.type == 1) {
                            twConfigs.push({
                                value: item.id,
                                label: self.$t(item.name) + '('+self.$t(item.description)+')'
                            });
                        } else if (item.type == 2) {
                            fwConfigs.push({
                                value: item.id,
                                label: self.$t(item.name) + '('+self.$t(item.description)+')'
                            });
                        } else if (item.type == 3) {
                            self.emblemFateConfigs.push(item);
                        }
                    });
                    tw.children = twConfigs;
                    fw.children = fwConfigs;
                    self.emblemEntryConfigs.push(tw);
                    self.emblemEntryConfigs.push(fw);
                    self.emblemEntryConfigs.push(special);
                    self.arrProp9 = arrProp9;
                    self.arrProp10 = arrProp10;
                    self.arrProp11 = arrProp11;
                    self.arrProp12 = arrProp12;
                    self.arrProp13 = arrProp13;
                    self.arrProp14 = arrProp14;
                    self.arrProp15 = arrProp15;

                    let arrProp6 = [];
                    let arrProp19 = [];
                    self.monsterConfigs.forEach(function(item) {
                        let monsterRace = item.race;
                        let monsterQuality = item.quality;
                        let hyperEvolution = item.hyper_evolution;
                        if (monsterQuality === 4 && monsterRace.indexOf("_") > -1) {
                            arrProp6.push(item);
                        }
                        if (hyperEvolution ===1){
                            arrProp19.push(item);
                        }

                    });
                    self.arrProp6 = arrProp6;
                    self.arrProp19 = arrProp19;

                    let arrProp7 = [];
                    res.war_groove_config.forEach(function(item) {
                        let type = item.type;
                        if (type === 3 || type === 4) {
                            arrProp7.push(item);
                        }
                    });
                    self.arrProp7 = arrProp7;
                    //self.glyphFateType = arr2;

                    self.evolutions = [];
                    for (var i in self.monsterConfigs) {
                        var arr = self.monsterConfigs[i].evolutions.split("@");
                        for (var j in arr) {
                            self.evolutions.push({
                                id: arr[j].split("#")[0],
                                material: arr[j].split("#")[1],
                                oid: self.monsterConfigs[i].id
                            })
                        }
                    }
                })
            },
            propQuery() {
                let self = this;
                let type = self.propForm.type;
                let id = self.propForm.id;
                let propConfig = [];
                self.propConfig.forEach(item => {
                    if (type !== '' && id !== '') {
                        if (id == item.id && type == item.big_type.toString()) {
                            propConfig.push(item);
                        }
                    } else if (type !== '' && id == '') {
                        if (type == item.big_type.toString()) {
                            propConfig.push(item);
                        }
                    } else if (type == '' && id !== '') {
                        if (id == item.id) {
                            propConfig.push(item);
                        }
                    } else {
                        propConfig = self.propConfig;
                    }
                })

                self.totalRow = propConfig.length;
                self.rawData = propConfig;
                self.dataHandled = propConfig;
            }
        }
    }
</script>

<style scoped>

</style>

<style lang="less">
    .prop-img {
        width: 50px;
        height: 50px;
    }
</style>



// WEBPACK FOOTER //
// src/views/plot_tools/prop_view.vue